<template>
  <div class="sidebar">
    <ul>
      <li>
        <img src="../../static/assets/logo@1x.png">
        <span>会员管家</span>
        <i class="el-icon-close" @click="closed"></i>
      </li>
      <li v-for="(item,i) in header"><a :href="item.a" style="color: #fff" @click="headerItem(i)">{{item.name}}</a></li>
    </ul>
  </div>
</template>

<script>
    export default {
        props:['sidebar','showMain'],
        name: "sidebar",
        data(){
            return{
                header:[{
                    name:'首页',
                    a:'#carousel'
                },{
                    name:'功能介绍',
                    a:'#function'
                },{
                    name:'解决方案',
                    a:'#solve'
                },{
                    name:'关于我们',
                    a:'#mainer'
                }]
            }
        },
        methods:{
            closed(){
                this.$emit('childByValue', this.sidebar)
            },
            headerItem(value){
                this.$emit('childByValue', value)
            }
        },

    }
</script>

<style scoped lang="less">
  .sidebar{
    position: fixed;
    top: 0;
    right: 0;
    width: 290px;
    height: 100%;
    z-index: 3000;
    background: #2F2F3C;
    ul{
      li{
        height: 50px;
        line-height: 50px;
        padding: 0 17px;
        text-align: left;
        border-bottom: 1px solid #FFF;
        a{

          display: block;
        }
      }
      li:nth-of-type(1){
        position:relative;
        height: 60px;
        img{
          height:55%;
          /*margin-top: 14px;*/
          vertical-align: middle;
          margin-right: 5px;
        }
        span{
          color: #fff;
          height: 60px;
          line-height: 60px;
          display: inline-block;
          font-size: 17px;
        }
        i{
          position: absolute;
          right: 22px;
          top: 16px;
          color: #fff;
          font-size: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue